import { render, staticRenderFns } from "./BoxGenitores.vue?vue&type=template&id=61585525&"
import script from "./BoxGenitores.vue?vue&type=script&lang=js&"
export * from "./BoxGenitores.vue?vue&type=script&lang=js&"
import style0 from "./BoxGenitores.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports